module.exports = __webpack_public_path__ + "media/images/landing_page/kazu_uzdevumi-9707aa294ec442a70b0fc5338aafbaf9.webp";